export const periodInputsTheme = {
  hint: 'palette.neutral.70',
  label: 'palette.tertiary.60',
};
